import { render, staticRenderFns } from "./Part8.vue?vue&type=template&id=c766208c&scoped=true"
import script from "./Part8.vue?vue&type=script&lang=js"
export * from "./Part8.vue?vue&type=script&lang=js"
import style0 from "./Part8.vue?vue&type=style&index=0&id=c766208c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c766208c",
  null
  
)

export default component.exports